export default __webpack_public_path__ + "static/media/FMS500-LIGHT.7b25211e.png";